import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IApplicationModalButtonWithHiddenPricesRenderProps} from "../ApplicationModalButtonWithHiddenPrices";

interface IProps extends IApplicationModalButtonWithHiddenPricesRenderProps {
    buttonText?: string;
}

export const ApplicationFormBoxHiddenPriceVariant = (props: IProps) => {
    const {handleClick, buttonText = "Odkryj cenę"} = props;

    return (
        <div className={hiddenWrapperStyle}>
            <Button
                variant="filled_primary"
                size="medium"
                onClick={handleClick}
                className={buttonStyle}
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.SIDEBAR_BUTTON_SHOW_PRICES}
            >
                {buttonText}
            </Button>

            <Text variant="info_txt_2" align="center" color="var(--colors-gray-700)" className={infoTextStyle}>
                Po odkryciu ceny tej oferty uzyskasz dostęp do wszystkich cen na portalu.
            </Text>
        </div>
    );
};

const hiddenWrapperStyle = css({
    width: "100%",
    backgroundColor: "var(--colors-gray-100)",
    borderRadius: 2,
    p: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    alignItems: "center"
});

const buttonStyle = css({
    width: "100%"
});

const infoTextStyle = css({
    textAlign: "center"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IApplicationModalButtonWithHiddenPricesRenderProps} from "../ApplicationModalButtonWithHiddenPrices";

interface IProps extends IApplicationModalButtonWithHiddenPricesRenderProps {
    buttonText?: string;
}

export const ApplicationFormBoxHiddenPriceVariant = (props: IProps) => {
    const {handleClick, buttonText = "Odkryj cenę"} = props;

    return (
        <div className={hiddenWrapperStyle}>
            <Button
                variant="filled_primary"
                size="medium"
                onClick={handleClick}
                className={buttonStyle}
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.SIDEBAR_BUTTON_SHOW_PRICES}
            >
                {buttonText}
            </Button>

            <Text variant="info_txt_2" align="center" color="var(--colors-gray-700)" className={infoTextStyle}>
                Po odkryciu ceny tej oferty uzyskasz dostęp do wszystkich cen na portalu.
            </Text>
        </div>
    );
};

const hiddenWrapperStyle = css({
    width: "100%",
    backgroundColor: "var(--colors-gray-100)",
    borderRadius: 2,
    p: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    alignItems: "center"
});

const buttonStyle = css({
    width: "100%"
});

const infoTextStyle = css({
    textAlign: "center"
});
